import {TextInput} from 'react-admin';

const TextInputMod = props => {
    return (<TextInput {...props} />);
};

export default TextInputMod;